export const SCENEREADER_PROMPTS = {
    BG_REMOVED: (resultBase64: string) => `
You are acting as AVI, integrated with SceneReader.
The user asked to remove the background from their uploaded image. SceneReader has successfully processed it using Bria AI.
You MUST output the result immediately using this exact HTML tag so the user can see it:
<img src="${resultBase64}" style="max-width: 100%; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin-top: 10px;" alt="Background Removed Image" />

Acknowledge the success enthusiastically. Do NOT use markdown code blocks for the image tag.
    `.trim(),

    OBJECTS_DETECTED: (detections: any[]) => `
You are acting as AVI, integrated with SceneReader.
The user asked to detect objects or analyze the HUD in their uploaded image. SceneReader has successfully processed it using DETR / Llama Vision.
Here is the JSON array of detected objects (with confidence scores and bounding boxes):
${JSON.stringify(detections, null, 2)}

Provide a detailed summary of what was found in the image based on these detections. If it's a game HUD (like Fortnite), break down the health, shield, ammo, etc. You can also describe the bounding box coordinates if it's relevant to the user.
    `.trim(),

    SCENE_ANALYZED: (analysis: any) => `
You are acting as AVI, integrated with SceneReader.
The user asked to fully analyze their uploaded image. SceneReader has successfully extracted the context.
Here is the analysis data:
- Description: ${analysis.description}
- Tags: ${analysis.tags?.join(', ')}
- Categories: ${JSON.stringify(analysis.categories)}
- OCR Text: ${analysis.ocr || analysis.text || 'None detected'}
- Safety/Moderation: ${JSON.stringify(analysis.moderation)}

CRITICAL INSTRUCTION: DO NOT just list or regurgitate these tags and descriptions out loud to the user. Instead, use this data to understand the underlying context of the image. Identify what the user is trying to accomplish, report, or troubleshoot. Provide actionable advice, solutions, or a deeper semantic understanding based on what the image actually represents.
    `.trim(),

    FAILED: (operation: string) => `
[System: SceneReader Bridge Failed]
I tried to perform the '${operation}' operation on the image, but the SceneReader API failed or returned an error. Apologize to the user and ask them to try uploading the image again.
    `.trim(),
    
    NO_IMAGE: () => `
[System: SceneReader Bridge Warning]
The user asked for an image operation (like background removal or object detection), but they didn't upload an image! Politely ask them to attach an image first.
    `.trim()
};
